import React from "react";
import "./ConfirmDeletePopup.css"

const ConfirmDeletePopup = ({
  isOpen,
  profileId,
  onCancel,
  onConfirmDelete,
}) => {

    if (isOpen) return null;

  return (
    <div className="ua-popup-overlay">
      <div className="ua-popup-content">
        <h3>Confirm Delete</h3>
        <p>Are you sure you want to delete profile <strong>{profileId}</strong>?</p>
        <p style={{ fontSize: "0.9rem", color: "#888" }}>
          Instead of deleting, would you prefer to archive this profile?
        </p>
        <div className="popup-actions">
          <button onClick={onCancel} className="btn-cancel">
            Cancel
          </button>
          <button onClick={onConfirmDelete} className="btn-delete">
            Confirm Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeletePopup;
